export const companiesMockData: Array<any> = [
    {
        id: 1,
        name: "Logistics Co.",
        city: "Springfield",
        zip: "62704",
        address: "123 Main St, Springfield, IL",
        officePhone: "9876543210",
        secondaryPhone: "9876543211",
        officeEmail: "info@logisticsco.com",
        hoursOfOperation: "9:00 AM - 5:00 PM",
        createdAt: "2023-01-15",
        updatedAt: "2024-12-01",
        drivers: [
            {
                id: 1,
                firstName: "John",
                lastName: "Doe",
                city: "Springfield",
                address: "456 Maple Ave, Springfield, IL",
                email: "john.doe@example.com",
                profile: "Senior Driver",
                contactNo: "9876543210",
                version: "1.0",
                licenseNumber: "DL12345",
                employmentType: "Full-time",
                joiningDate: "2022-05-10",
                createdAt: "2022-05-01",
                status: "Active",
            },
            {
                id: 2,
                firstName: "Jane",
                lastName: "Smith",
                city: "Springfield",
                address: "789 Birch Rd, Springfield, IL",
                email: "jane.smith@example.com",
                profile: "Junior Driver",
                contactNo: "9876543211",
                version: "1.0",
                licenseNumber: "DL67890",
                employmentType: "Part-time",
                joiningDate: "2023-01-15",
                createdAt: "2023-01-01",
                status: "Active",
            },
        ],
        vehicles: [
            { id: 101, make: "Ford", model: "F-150", vin: "1FTFW1E57JKC12345" },
            { id: 102, make: "Chevrolet", model: "Silverado", vin: "3GCUKREC1JG123456" },
        ],
    },
    {
        id: 2,
        name: "Fast Freight",
        city: "Dallas",
        zip: "75201",
        address: "456 Elm St, Dallas, TX",
        officePhone: "9123456789",
        secondaryPhone: "9123456790",
        officeEmail: "contact@fastfreight.com",
        hoursOfOperation: "8:00 AM - 6:00 PM",
        createdAt: "2022-09-10",
        updatedAt: "2024-11-15",
        drivers: [
            {
                id: 3,
                firstName: "Alice",
                lastName: "Johnson",
                city: "Dallas",
                address: "123 Cedar St, Dallas, TX",
                email: "alice.johnson@example.com",
                profile: "Contract Driver",
                contactNo: "9123456789",
                version: "1.2",
                licenseNumber: "DL98765",
                employmentType: "Contract",
                joiningDate: "2021-09-20",
                createdAt: "2021-09-10",
                status: "Active",
            },
            {
                id: 4,
                firstName: "Bob",
                lastName: "Brown",
                city: "Dallas",
                address: "789 Oak Dr, Dallas, TX",
                email: "bob.brown@example.com",
                profile: "Lead Driver",
                contactNo: "9123456790",
                version: "1.1",
                licenseNumber: "DL54321",
                employmentType: "Full-time",
                joiningDate: "2020-07-01",
                createdAt: "2020-06-20",
                status: "Inactive",
            },
        ],
        vehicles: [
            { id: 103, make: "Ram", model: "1500", vin: "1C6SRFJT8KN123456" },
            { id: 104, make: "Toyota", model: "Tundra", vin: "5TFDY5F18JX123456" },
        ],
    },
    {
        id: 3,
        name: "Quick Haul",
        city: "Seattle",
        zip: "98101",
        address: "789 Oak St, Seattle, WA",
        officePhone: "8901234567",
        secondaryPhone: "8901234568",
        officeEmail: "support@quickhaul.com",
        hoursOfOperation: "7:00 AM - 7:00 PM",
        createdAt: "2021-06-01",
        updatedAt: "2024-10-05",
        drivers: [
            {
                id: 5,
                firstName: "Charlie",
                lastName: "Davis",
                city: "Seattle",
                address: "456 Pine Ave, Seattle, WA",
                email: "charlie.davis@example.com",
                profile: "Junior Driver",
                contactNo: "8901234567",
                version: "1.0",
                licenseNumber: "DL11223",
                employmentType: "Part-time",
                joiningDate: "2023-03-15",
                createdAt: "2023-03-10",
                status: "Active",
            },
        ],
        vehicles: [
            { id: 105, make: "GMC", model: "Sierra", vin: "1GTU9FEL0KZ123456" },
        ],
    },
    {
        id: 4,
        name: "National Carriers",
        city: "Miami",
        zip: "33101",
        address: "321 Pine St, Miami, FL",
        officePhone: "8765432109",
        secondaryPhone: "8765432110",
        officeEmail: "hello@nationalcarriers.com",
        hoursOfOperation: "10:00 AM - 4:00 PM",
        createdAt: "2020-03-20",
        updatedAt: "2024-09-25",
        drivers: [],
        vehicles: [],
    },
];

